// removed by extract-text-webpack-plugin
module.exports = {"chartCard":"chartCard___2Imu5","meta":"meta___3BRK4","action":"action___H-ucR","total":"total___1eULe","content":"content___26QeN","contentFixed":"contentFixed___3ZxFP","footer":"footer___dJC-t"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Charts/ChartCard/index.less
// module id = 422
// module chunks = 0 1